export const disableDismiss = (event: any, reason: 'backdropClick' | 'escapeKeyDown') => {
  if (reason && (reason === "backdropClick" || reason === 'escapeKeyDown'))
    return;
};

/**
 * Generates a close event handler function that'll execute
 * the passed in function.
 */
export const enableDismiss = (close: (event: any, reason: 'backdropClick' | 'escapeKeyDown') => void) => {
  return (event: any, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason && (reason === "backdropClick" || reason === 'escapeKeyDown'))
      close(event, reason);
  };
};